<div class="login-container">
  <!-- Background Animation -->
  <div class="bg-animation">
    <div class="floating-shape shape-1"></div>
    <div class="floating-shape shape-2"></div>
    <div class="floating-shape shape-3"></div>
    <div class="floating-shape shape-4"></div>
    <div class="floating-shape shape-5"></div>
    <div class="floating-shape shape-6"></div>
  </div>

  <!-- Main Login Card -->
  <div class="login-card">
    <!-- Logo Section -->
    <div class="logo-section">
      <img class="logo" src="../../assets/icons/logo_rosa.png" alt="Logo Chiesi" />
      <h1 class="welcome-title">Bem-vindo de volta!</h1>
      <p class="welcome-subtitle">Acesse sua conta para continuar</p>
    </div>

    <!-- Loading State -->
    @if(loading) {
      <div class="loading-state">
        <div class="loading-spinner">
          <mat-spinner></mat-spinner>
        </div>
      </div>
    } @else {
      <!-- Email Form -->
      @if (enterEmail) {
        <div class="form-section">
          <div class="input-group">
            <mat-form-field appearance="outline" class="modern-input">
              <mat-label>
                <mat-icon class="label-icon">mail_outline</mat-icon>
                Email
              </mat-label>
              <input
                matInput
                placeholder="seu@email.com"
                [formControl]="email"
                (blur)="updateErrorMessage()"
                required
                autocomplete="email"
              />
              @if (email.invalid) {
                <mat-error class="error-message">{{errorMessage()}}</mat-error>
              }
            </mat-form-field>
          </div>

          <button 
            (click)="touchPreLogin()" 
            class="primary-btn" 
            mat-raised-button
            [disabled]="email.invalid">
            <mat-icon>send</mat-icon>
            Enviar Código
          </button>
        </div>
      } @else {
        <!-- OTP Form -->
        <div class="form-section">
          <div class="otp-header">
            <h2 class="otp-title">Verificação em duas etapas</h2>
            <p class="otp-subtitle">Digite o código de 5 dígitos enviado para seu email</p>
          </div>

          <div class="otp-input-container">
            <ng-otp-input 
              allowNumbersOnly="true" 
              [formControl]="code" 
              [config]="{ 
                length: 5, 
                inputClass: 'modern-otp-input',
                containerStyles: { 'width': '100%' }
              }">
            </ng-otp-input>
          </div>

          @if (code.invalid) {
            <div class="otp-error">
              <mat-icon>error_outline</mat-icon>
              <span>{{errorMessage()}}</span>
            </div>
          }

          <!-- Resend Code -->
          @if (resendCode) {
            <div class="resend-section">
              <p class="resend-text">Não recebeu o código?</p>
              <button 
                class="resend-btn" 
                mat-stroked-button
                (click)="touchResendCode()" 
                [disabled]="sendCount < 60">
                @if (sendCount < 60) {
                  <span>Aguarde {{sendCount}}s</span>
                } @else {
                  <span>
                    <mat-icon>refresh</mat-icon>
                    Reenviar código
                  </span>
                }
              </button>
            </div>
          }

          <!-- Action Buttons -->
          <div class="action-buttons">
            <button 
              [disabled]="code.value?.length! < 5" 
              (click)="touchLogin()" 
              class="primary-btn full-width" 
              mat-raised-button>
              <mat-icon>login</mat-icon>
              Entrar
            </button>

            <button 
              (click)="goBack()" 
              class="secondary-btn full-width" 
              mat-stroked-button>
              <mat-icon>arrow_back</mat-icon>
              Voltar
            </button>
          </div>
        </div>
      }
    }

    <!-- Footer -->
    <div class="login-footer">
      <div class="footer-links">
        <!-- <a href="#" class="footer-link">Ajuda</a> -->
        <!-- <span class="separator">·</span> -->
        <a href="https://www.chiesi.com.br/privacidade/" target="_blank" class="footer-link">Política de Privacidade</a>
        <span class="separator">·</span>
        <a href="/regulation" class="footer-link" (click)="goToRegulation()">Termos de Uso</a>
      </div>
      <p class="copyright">© {{ allRightsReservedDate }} Chiesi. Todos os direitos reservados.</p>
    </div>
  </div>
</div>
